// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"loK7H":[function(require,module,exports) {
/**
* Close an answer section residing in the FAQ on the home page
* @param {Number} val The answer section that needs to be closed
*/ function closeAnswSection(val) {
    document.getElementById(`question${val}`).classList.remove("rounded-t-lg");
    document.getElementById(`question${val}`).classList.add("rounded-lg");
    const p = document.getElementById(`para${val}`);
    const plus = document.getElementById(`plus${val}`);
    const minus = document.getElementById(`minus${val}`);
    plus.classList.remove("hidden");
    plus.classList.add("block");
    minus.classList.add("hidden");
    minus.classList.remove("block");
    p.classList.add("hidden");
    p.classList.remove("block");
    p.classList.add("exiting");
    p.classList.remove("expanded");
}
window.addEventListener("newLang", ()=>{
    document.getElementById("homeButton").href = `/?lang=${window.lang}`;
});
/**
 * Open the section of the question with the given number
 * This closes all other sections
 * @param {Number} val section number
 */ window.openSection = function openSection(val) {
    // Close all other sections
    const potOpen = [
        1,
        2,
        3,
        4
    ];
    const index = potOpen.indexOf(val);
    potOpen.splice(index, 1);
    potOpen.forEach((section)=>closeAnswSection(section));
    // Open the section
    const p = document.getElementById(`para${val}`);
    const plus = document.getElementById(`plus${val}`);
    const minus = document.getElementById(`minus${val}`);
    [
        p,
        plus,
        minus
    ].forEach((DOMElement)=>{
        DOMElement.classList.toggle("hidden");
        DOMElement.classList.toggle("block");
    });
    const expanded = p.classList.contains("hidden");
    if (expanded) {
        p.classList.remove("expanded");
        p.classList.add("exiting");
    } else {
        p.classList.add("expanded");
        p.classList.remove("exiting");
    }
    document.getElementById(`question${val}`).classList.toggle("rounded-t-lg");
    document.getElementById(`question${val}`).classList.toggle("rounded-lg");
};

},{}]},["loK7H"], "loK7H", "parcelRequire5f1f")

//# sourceMappingURL=faq.e889c0c3.js.map
